import React from 'react';

const SecuritiesSubAccountFormModal = React.lazy(() => import('../components/FormModal'));
const securitiesSubAccountModalRegistry = {
    core_securitiesSubAccountId: SecuritiesSubAccountFormModal
};
export default securitiesSubAccountModalRegistry;
